import { selectCurrentAccount, selectCurrentSubscription } from "fond/api";
import { BillingCycle } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

/**
 * Gets the active billing cycle of the current (or only) subscription.
 */
export const useGetActiveBillingCycle = (): BillingCycle | undefined => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const currentSubscription = useAppSelector((state) => currentAccount && selectCurrentSubscription(state, currentAccount.ID));
  return currentSubscription?.BillingCycles.find(({ Status }) => Status === "ACTIVE");
};
